<style>
    #packagesgetstartedtasks-copy-field > * {
        display: inline-block;
        margin-right: 2ex;
    }
    .packagesgetstartedtasks-list-header {
        color:  rgba(0,0,0,0.6);
        font-size: small;
        font-weight: bold;
    }
</style>
<template>
    <div class="mb-10" v-model="key">
        <confirm-dialog
            ref="confirm"
            :headline="$translate('Are you sure?')"
            :text="$translate('All settings made on this page will be overwritten and cannot be undone')"
            :button="$translate('Copy')"
        />
        <div id="packagesgetstartedtasks-copy-field" v-if="copyField">
            <span class="text-subtitle-1">{{ $translate('Copy getting started steps from branch package') }}</span>
            <formfield :field="copyField" />
            <v-btn color="info" @click="confirmCopy" :loading="loading.copy" :disabled="!copyField.value">{{ $translate('Copy') }}</v-btn>
        </div>

        <div v-if="items.length">
            <v-text-field
                class="col-lg-5"
                v-model="searchText"
                append-icon="mdi-magnify"
                :label="$translate('Search card or guide ID')"
                single-line
                hide-details
            />

            <v-list class="elevation-1">
                <v-list-item>
                    <v-row>
                        <v-col cols=1 class="packagesgetstartedtasks-list-header">
                            {{ $translate('Order') }}
                        </v-col>
                        <v-col cols=5 class="packagesgetstartedtasks-list-header">
                            {{ $translate('Getting started step') }}
                        </v-col>
                        <v-col cols=3 class="packagesgetstartedtasks-list-header">
                            {{ $translate('Contains guides') }}
                        </v-col>
                        <v-col cols=2 class="packagesgetstartedtasks-list-header">
                            {{ $translate('Show in Getting started') }}
                        </v-col>
                    </v-row>
                </v-list-item>
                <draggable v-model="items" @start="drag=true" @end="drag=false">
                    <v-list-item v-for="item in filteredItems" :key="item.id">
                        <v-row>
                            <v-col cols=1 style="text-align: center;">
                                {{ item.order }}
                            </v-col>
                            <v-col cols=5>
                                {{ item.title }}
                            </v-col>
                            <v-col cols=3>
                                {{item.guide ? item.guide.title : ''}}
                            </v-col>
                            <v-col cols=2>
                                <v-checkbox class="mt-0 pt-0" v-model="item.show" @click.native.stop @change="update"></v-checkbox>
                            </v-col>
                        </v-row>
                    </v-list-item>
                </draggable>
            </v-list>

        </div>
    </div>
</template>
<script>
import Draggable from 'vuedraggable';

export default {
    name: 'packageGetStartedTasks',
    props: ['package'],
    components: {
        Draggable,
    },
    data() {
        return {
            key: 0,
            loading: { copy: false },
            searchText: '',
            copyField: null,
            items: [],
            drag: false
        };
    },
    computed: {
        filteredItems() {
            if (!this.searchText) { return this.items; }
            let text = this.searchText.toLowerCase();
            return _.filter(this.items, item => (item.title.toLowerCase().includes(text) || item.guide?.title.toLowerCase().includes(text)));
        }
    },
    mounted() {
        this.copyField = {
            id: 'copy',
            label: this.$translate('Select package'),
            type: 'select',
            value: null,
            required: false,
            options: []
        };
        this.loadPackages();
        this.loadItems();
    },
    watch: {
        package() {
            this.loadItems();
        },
        drag(newValue, oldValue) {
            if (newValue == false && oldValue) {
                this.update();
            }
        }
    },
    methods: {
        loadPackages() {
            fetch('/api/package/get').then(r => r.json()).then(packages => {
                this.copyField.options = packages;
            });
        },
        loadItems() {
            fetch('/api/package/getstarted/task/get').then(r => r.json()).then(tasks => {
                tasks.forEach(task => {
                    task.show = !!_.find(this.package.tasks, { id: task.id });
                    if (task.show) {
                        task.order = _.indexOf(this.package.task_order, task.id)+1;
                    }
                });
                this.items = _.sortBy(tasks, ['order']);
            });
        },
        update() {
            let order = 1;
            this.items.forEach(task => (task.order = task.show ? order++ : null));
            let tasks = _.filter(this.items, task => task.show);
            this.$emit('update', tasks);
            this.key++;
        },
        confirmCopy() {
            this.$refs.confirm.show().then(this.copy);
        },
        copy() {
            this.loading.copy = true;
            fetch(`/api/package/getstarted/task/get?package_id=${this.copyField.value}`).then(r => r.json()).then(tasks => {
                this.items.forEach(task => {
                    task.show = !!_.find(tasks, { id: task.id });
                });
                this.copyField.value = null;
                this.update();
                this.loading.copy = false;
            });
        },
        rowClick(task) {
            task.show = !task.show;
            this.update()
        }
    }
};
</script>
